export const purchaseUrls = {
  base: 'https://www.compradigitalya.com/cart/43094897885255:1',
  premium: 'https://www.compradigitalya.com/cart/43094898180167:1',
}

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/nZnECMdxn78ZS1nsZDnzyq/ChatGPT_Image_15_ago_2026,_05_23_18_p.m..png'

export const shortTestimonials = [
  {
    initials: 'MG',
    name: 'Marcela G.',
    place: 'Córdoba',
    text: 'Organicé todo el año en una tarde. Las progresiones me ahorran horas cada semana.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    place: 'Rosario',
    text: 'Las progresiones de barras por fin tienen sentido. Los 50 circuitos listos son el hit de mis clases.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    place: 'Buenos Aires',
    text: 'Mis clases de nivel avanzado por fin enganchan. El Tomo de Planificación vale cada peso.',
  },
]

export const fullTestimonials = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    place: 'Mendoza · 41 años · Entrenadora de club',
    text: 'Las fichas de progresión me salvaron la vida. Antes cada alumna avanzaba "cuando me parecía"; ahora tengo criterios medibles por etapa. Mis alumnas avanzan de forma visible y los padres lo notan en la reunión trimestral.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    place: 'La Plata · 27 años · Profesora de Educación Física',
    text: 'Mis alumnas de nivel inicial llegaron a hacer la rueda en 3 semanas. Las progresiones paso a paso funcionan de verdad: sé qué corregir, cuándo asistir y cuándo dejarlas solas. Es la primera vez que no improviso una clase.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    place: 'Neuquén · 35 años · Entrenador de Gimnasia Artística',
    text: 'El sistema de evaluación fue un antes y un después. Ahora sé exactamente dónde está cada alumna y qué le falta para pasar de nivel. Los informes para padres me sacaron de encima la charla más incómoda del año.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    place: 'Buenos Aires · 44 años · Director de escuela deportiva',
    text: 'Con los 50 circuitos listos, en 10 minutos tengo la clase armada. Antes me llevaba una hora los domingos. Multiplicá eso por 40 semanas y entendés por qué este combo se pagó solo en la primera quincena.',
  },
  {
    initials: 'VL',
    name: 'Valentina L.',
    place: 'Mar del Plata · 31 años · Entrenadora de nivel formativo',
    text: 'Tengo grupos mixtos de 8 a 14 años y antes entrenaba al promedio. Con las variantes por nivel de cada ejercicio, en la misma clase trabajo inicial e intermedio sin dejar a nadie afuera. Eso me duplicó la retención del grupo.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Fundamentos y Preparación',
    period: 'Base técnica y corporal',
    content: [
      'Calentamiento específico y movilidad para gimnasia artística.',
      'Posiciones corporales: hollow body, arch body y control postural.',
      'Rodamientos, suspensión y trabajo de equilibrio inicial.',
      'Preparación física adaptada a alumnas sin experiencia previa.',
    ],
  },
  {
    icon: '📗',
    name: 'Suelo: Habilidades Acrobáticas',
    period: 'Del rodamiento al flic-flac',
    content: [
      'Rodamientos, rueda, vertical y puente con progresión completa.',
      'Rondada y flic-flac supervisado etapa por etapa.',
      'Saltos, giros y combinaciones acrobáticas.',
      'Errores frecuentes y correcciones del entrenador en cada habilidad.',
    ],
  },
  {
    icon: '📙',
    name: 'Salto: Técnica y Progresiones',
    period: 'Carrera, batida y mesa completa',
    content: [
      'Carrera, batida y uso del trampolín con criterios claros.',
      'Bloqueo y mesa completa paso a paso.',
      'Saltos agrupado y carpado con progresión segura.',
      'Giros supervisados y notas de spotting.',
    ],
  },
  {
    icon: '📕',
    name: 'Barras Asimétricas',
    period: 'Agarre, kip y salidas',
    content: [
      'Agarre, suspensión activa y balanceo controlado.',
      'Kip y cast con progresión de etapas medibles.',
      'Giros y transiciones entre barras.',
      'Salidas completas con protocolo de asistencia.',
    ],
  },
  {
    icon: '📓',
    name: 'Viga de Equilibrio',
    period: 'Suelo → banco → viga baja → viga alta',
    content: [
      'Progresión de superficie: suelo, banco, viga baja y viga alta.',
      'Caminatas, posiciones y giros sobre viga.',
      'Saltos y combinaciones con criterios de avance.',
      'Salidas y trabajo de confianza en altura.',
    ],
  },
  {
    icon: '📔',
    name: 'Planificación Profesional',
    period: 'Clases, rotación y evaluación',
    content: [
      'Clases de 45 a 120 minutos ya estructuradas.',
      'Rotación de aparatos para grupos de distintos tamaños.',
      'Planificación semanal y mensual lista para usar.',
      'Evaluaciones integradas por aparato y nivel.',
    ],
  },
]

export const tomoIncludes = [
  'Ejercicios con series, repeticiones y tiempos',
  'Progresiones completas etapa por etapa',
  'Criterios de avance específicos y medibles',
  'Errores frecuentes + correcciones del entrenador',
  'Spotting: cuándo y cómo asistir',
  'Circuitos listos para aplicar',
  'Clases completas armadas de principio a fin',
  'Fichas de evaluación por aparato y nivel',
  'Notas de seguridad en habilidades avanzadas',
]

export const bonuses = [
  [
    '01',
    '🏋️',
    'Banco de Preparación Física',
    '61 ejercicios específicos de gimnasia artística + 5 circuitos completos de preparación física por nivel.',
    '$12.000',
  ],
  [
    '02',
    '🤸',
    'Movilidad y Flexibilidad',
    'Rutinas de 5, 10, 15 y 20 minutos organizadas por zona corporal, listas para insertar en cualquier clase.',
    '$10.000',
  ],
  [
    '03',
    '🔁',
    '50 Circuitos Profesionales',
    'Circuitos por aparato y por nivel, listos para aplicar hoy mismo sin armar nada.',
    '$15.000',
  ],
  [
    '04',
    '📋',
    '30 Clases Listas para Aplicar',
    'Clases de 45 a 120 minutos completamente armadas. Copiá y usá directo en el gimnasio.',
    '$12.000',
  ],
  [
    '05',
    '🗺️',
    'Banco Maestro de Progresiones',
    '34 progresiones con criterios de avance definidos para cada habilidad y cada aparato.',
    '$12.000',
  ],
  [
    '06',
    '📊',
    'Evaluación y Seguimiento',
    'Fichas de evaluación, informes para padres y protocolos de seguimiento por trimestre.',
    '$9.000',
  ],
] as const

export const academiaRows = [
  ['Improvisás semana a semana', 'Macrociclo de 48 semanas listo'],
  ['No sabés qué trabajar en cada mes', 'Plan trimestral por nivel y objetivos'],
  ['Llegás tarde a preparar competencias', 'Protocolo de 8 semanas pre-competencia'],
  ['Sin métricas de progreso anual', 'Evaluación anual comparativa completa'],
  ['No sabés cuándo cambiar de nivel', 'Criterios y timing por trimestre definidos'],
  ['Fin del año igual que el anterior', 'El año siguiente empieza con el plan listo'],
] as const

export const academiaIncludes = [
  'Macrociclo de 48 semanas',
  '4 trimestres detallados',
  'Plan por nivel',
  'Rutinas de gestión del entrenador',
  'Protocolo pre-competencia',
  'Kit completo de materiales',
  'Evaluación anual',
]

export const faqs = [
  [
    '¿Sirve para todos los niveles?',
    'Sí. Desde alumnas sin experiencia hasta nivel avanzado. Cada ejercicio tiene variantes por nivel, así que podés tener grupos mixtos y trabajar con todas en la misma clase sin dejar a nadie afuera.',
  ],
  [
    '¿Cómo recibo el material?',
    '100% digital en PDF. En menos de 5 minutos recibís el acceso en tu correo. Podés imprimirlo, usarlo en tablet o en el teléfono a pie de pista.',
  ],
  [
    '¿Qué diferencia hay con lo que encuentro gratis en internet?',
    'El material gratuito son ejercicios sueltos sin sistema. Este es un programa completo con progresiones etapa por etapa, criterios de avance medibles y clases listas. Es la diferencia entre tener ingredientes y tener la receta completa.',
  ],
  [
    '¿Tiene garantía real?',
    'Sí. 7 días sin preguntas. Si no cumple lo prometido, devolvemos el 100%. Sin esperas, sin formularios, sin drama.',
  ],
  [
    '¿Necesito un gimnasio equipado con los 4 aparatos?',
    'No para empezar. Los Tomos 1 y 2 se trabajan con colchonetas y espacio de suelo. Viga, salto y barras incluyen progresiones sobre banco, línea en el piso y superficies bajas para clubes con equipamiento limitado.',
  ],
  [
    '¿Incluye cómo y cuándo asistir (spotting)?',
    'Sí. Cada habilidad de riesgo tiene su apartado de spotting: posición del entrenador, momento exacto de la asistencia y criterios para dejar de asistir, además de notas de seguridad en habilidades avanzadas.',
  ],
  [
    '¿Sirve si doy clases en colegio o escuela deportiva, no en club de alto rendimiento?',
    'Sí, es su uso más frecuente. Las clases están armadas de 45 a 120 minutos con rotación de aparatos, ideal para grupos numerosos de colegio, escuelitas municipales y escuelas deportivas.',
  ],
  [
    '¿Cuánto tarda en armar una clase con el material?',
    'Entre 5 y 10 minutos. Elegís el nivel, tomás el circuito del aparato del día y la clase queda cerrada. Con el bono de 30 clases listas, directamente copiás y aplicás.',
  ],
  [
    '¿Puedo usarlo con mis alumnas que compiten?',
    'Sí. Las progresiones llegan a nivel avanzado y el Tomo 6 integra evaluaciones. Si además querés el año competitivo planificado semana a semana, la opción Combo + Academia 12 Meses incluye el protocolo de 8 semanas pre-competencia.',
  ],
  [
    '¿Está adaptado a Argentina y puedo imprimirlo?',
    'Sí a las dos cosas. Terminología, ejemplos y precios están adaptados a Argentina, y todos los PDF están optimizados para imprimir, incluidas las fichas de evaluación y las planillas de seguimiento.',
  ],
] as const

export const recentPurchases = [
  ['Marcela G.', 'Córdoba', 'Combo Completo Gimnasia Artística'],
  ['Laura P.', 'Rosario', 'Combo + Academia 12 Meses'],
  ['Cecilia R.', 'Mendoza', 'Combo Completo Gimnasia Artística'],
  ['Sofía C.', 'La Plata', 'Combo + Academia 12 Meses'],
  ['Pablo A.', 'Neuquén', 'Combo Completo Gimnasia Artística'],
  ['Roberto M.', 'Buenos Aires', 'Combo + Academia 12 Meses'],
  ['Valentina L.', 'Mar del Plata', 'Combo Completo Gimnasia Artística'],
  ['Julieta F.', 'San Miguel de Tucumán', 'Combo Completo Gimnasia Artística'],
  ['Damián S.', 'Salta', 'Combo + Academia 12 Meses'],
  ['Rocío B.', 'Bahía Blanca', 'Combo Completo Gimnasia Artística'],
] as const
